import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { FilterChip } from '~/components/AiSearchChips/FilterChip/FilterChip';
import { useSettingsChipTone } from '~/components/AiSearchChips/settingsChipTone';
import { serviceAlternatives } from '../serviceConditionDisplay';
import { summarizeServicePredicate } from '../summarizeServicePredicate';
import { operatorLabel } from './ServiceConditionChip.utils';
export const ServiceConditionChip = (param)=>{
    let { testId, grammar, quantifier, predicate, onToggleQuantifier, onRemove } = param;
    var _ref, _ref1;
    const { texts: t, summaryBi } = grammar;
    const tone = useSettingsChipTone();
    const alternatives = serviceAlternatives(predicate, t);
    const quantifierLabel = operatorLabel(quantifier, (_ref = alternatives === null || alternatives === void 0 ? void 0 : alternatives.isHas) !== null && _ref !== void 0 ? _ref : false, t);
    const useSegments = alternatives != null && alternatives.labels.length > 1;
    const valueSegments = useSegments ? alternatives.labels.map((label)=>({
            label
        })) : undefined;
    return /*#__PURE__*/ _jsx(FilterChip, {
        testId: testId,
        fieldLabel: t.servicesLabel(),
        operator: quantifierLabel == null ? undefined : {
            label: quantifierLabel,
            onToggle: onToggleQuantifier,
            biName: summaryBi.toggleQuantifier
        },
        valueSegments: valueSegments,
        combinator: useSegments ? t.orConnector() : undefined,
        valueLabel: useSegments ? undefined : (_ref1 = alternatives === null || alternatives === void 0 ? void 0 : alternatives.labels[0]) !== null && _ref1 !== void 0 ? _ref1 : summarizeServicePredicate(predicate, t),
        onRemove: onRemove,
        removeBiName: summaryBi.remove,
        tone: tone
    });
};
